import { getKeycloak } from "./keycloak"
import { isSessionIdleLocked } from "./sessionIdle"

export async function getValidToken() {
  const kc = getKeycloak()

  if (!kc.authenticated) {
    try {
      await kc.login({ redirectUri: window.location.href })
    } catch (err) {
      console.error("Login redirect failed", err)
    }
    return null
  }

  if (isSessionIdleLocked()) {
    return kc.token || localStorage.getItem("authToken")
  }

  try {
    await kc.updateToken(30)
    if (kc.token) {
      localStorage.setItem("authToken", kc.token)
    }
    return kc.token
  } catch (err) {
    console.error("Token refresh failed", err)
    localStorage.removeItem("authToken")
    try {
      await kc.login({ redirectUri: window.location.href })
    } catch (loginErr) {
      console.error("Login redirect failed after token refresh error", loginErr)
      await kc.logout({ redirectUri: window.location.origin })
    }
    return null
  }
}
